import { DialogActions, DialogContent, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { getWorkSpaceApiKeys, getSecretKeyDetails } from 'wisestep-api';
import { WsButton, WsDialog, WsDialogSize, WsTypography, WsTypoVariants } from 'wisestep-base';

import { failed } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';

export interface drawerProps {
  openDrawer: boolean;
  workspaceId: string;
  onClose(): void;
}

const ApiKeysModal = ({ openDrawer, workspaceId, onClose }: drawerProps) => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [apiKeys, setApiKeys] = useState<{ apiKey: string; secretKey: string }[]>([]);

  const getSecretKeyData = async (event: any, apiKey: string, index: number) => {
    try {
      event.preventDefault();
      const response = await getSecretKeyDetails(apiKey);
      const previousApiKeys = [...apiKeys];
      previousApiKeys[index].secretKey = response.data.secret;
      setApiKeys(previousApiKeys);
    } catch {
      setNotification(failed(''));
    }
  };

  useEffect(() => {
    const fetchApiKeys = async () => {
      const response = await getWorkSpaceApiKeys(workspaceId ?? '');
      setApiKeys(
        response.data?.map((apiKey) => {
          return {
            apiKey: apiKey,
            secretKey: '',
          };
        })
      );
    };
    fetchApiKeys();
  }, [workspaceId]);

  return (
    <WsDialog openDialog={openDrawer} size={WsDialogSize.MEDIUM}>
      <DialogContent>
        <Grid container spacing={1} m={1}>
          <Grid item xs={4} textAlign="center">
            <WsTypography bold variant={WsTypoVariants.TITLE}>
              API Key
            </WsTypography>
          </Grid>
          <Grid item xs={8} textAlign="center">
            <WsTypography bold variant={WsTypoVariants.TITLE}>
              Secret Key
            </WsTypography>
          </Grid>
          {apiKeys.map((apiKey, index) => (
            <>
              <Grid item xs={4} textAlign="center">
                <WsTypography>{apiKey?.apiKey}</WsTypography>
              </Grid>
              <Grid item xs={8} textAlign="center">
                {apiKey.secretKey ? (
                  <WsTypography>{apiKey.secretKey}</WsTypography>
                ) : (
                  <WsButton onClick={(event) => getSecretKeyData(event, apiKey.apiKey, index)}>
                    Get Secret Key
                  </WsButton>
                )}
              </Grid>
            </>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions
        sx={{
          paddingBottom: 1,
          marginRight: 2,
          marginBottom: 2,
        }}
      >
        <WsButton size="medium" variant="contained" onClick={() => onClose()}>
          Close
        </WsButton>
      </DialogActions>
    </WsDialog>
  );
};

export default ApiKeysModal;
